"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateGender = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const translateGender = (gender) => {
    const dict = {
        male: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/utils/gender:male', defaultMessage: 'Male' })),
        female: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/utils/gender:female', defaultMessage: 'Female' })),
    };
    if (!gender)
        return undefined;
    return dict[gender];
};
exports.translateGender = translateGender;
//# sourceMappingURL=gender.js.map